import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["backgroundColor", "circleCheck", "plusButtonBoolean", "avatarBoolean", "cardTitle", "cardTextAlignment", "description", "richTextDescription", "imagePath", "imageAltText", "cardContentText", "dateOfCardText", "branding", "avatarAltText", "avatarImgPath", "theme", "buttonText", "buttonUrl", "checked", "eyebrow", "showBorder", "showCardShadow", "eyebrowColor", "eyebrowVariant", "eyebrowTextTransform", "focalPointImage", "sx", "buttonIcon", "buttonIconPosition", "tc", "allCards"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Card, useMediaQuery, TAGTypography, RichText } from '../../..';
import React from 'react';
import DefaultLayout from './DefaultLayout';
import ImageRightLayout from './ImageRightLayout';
import ImageLeftLayout from './ImageLeftLayout';

var TAGCard = function TAGCard(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
      _ref$circleCheck = _ref.circleCheck,
      circleCheck = _ref$circleCheck === void 0 ? false : _ref$circleCheck,
      _ref$plusButtonBoolea = _ref.plusButtonBoolean,
      plusButtonBoolean = _ref$plusButtonBoolea === void 0 ? false : _ref$plusButtonBoolea,
      _ref$avatarBoolean = _ref.avatarBoolean,
      avatarBoolean = _ref$avatarBoolean === void 0 ? false : _ref$avatarBoolean,
      _ref$cardTitle = _ref.cardTitle,
      cardTitle = _ref$cardTitle === void 0 ? '' : _ref$cardTitle,
      _ref$cardTextAlignmen = _ref.cardTextAlignment,
      cardTextAlignment = _ref$cardTextAlignmen === void 0 ? 'start' : _ref$cardTextAlignmen,
      description = _ref.description,
      richTextDescription = _ref.richTextDescription,
      _ref$imagePath = _ref.imagePath,
      imagePath = _ref$imagePath === void 0 ? '' : _ref$imagePath,
      _ref$imageAltText = _ref.imageAltText,
      imageAltText = _ref$imageAltText === void 0 ? '' : _ref$imageAltText,
      _ref$cardContentText = _ref.cardContentText,
      cardContentText = _ref$cardContentText === void 0 ? '' : _ref$cardContentText,
      _ref$dateOfCardText = _ref.dateOfCardText,
      dateOfCardText = _ref$dateOfCardText === void 0 ? '' : _ref$dateOfCardText,
      branding = _ref.branding,
      _ref$avatarAltText = _ref.avatarAltText,
      avatarAltText = _ref$avatarAltText === void 0 ? '' : _ref$avatarAltText,
      _ref$avatarImgPath = _ref.avatarImgPath,
      avatarImgPath = _ref$avatarImgPath === void 0 ? '' : _ref$avatarImgPath,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? undefined : _ref$theme,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? '' : _ref$buttonText,
      _ref$buttonUrl = _ref.buttonUrl,
      buttonUrl = _ref$buttonUrl === void 0 ? '' : _ref$buttonUrl,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$eyebrow = _ref.eyebrow,
      eyebrow = _ref$eyebrow === void 0 ? '' : _ref$eyebrow,
      _ref$showBorder = _ref.showBorder,
      showBorder = _ref$showBorder === void 0 ? true : _ref$showBorder,
      _ref$showCardShadow = _ref.showCardShadow,
      showCardShadow = _ref$showCardShadow === void 0 ? false : _ref$showCardShadow,
      _ref$eyebrowColor = _ref.eyebrowColor,
      eyebrowColor = _ref$eyebrowColor === void 0 ? '' : _ref$eyebrowColor,
      _ref$eyebrowVariant = _ref.eyebrowVariant,
      eyebrowVariant = _ref$eyebrowVariant === void 0 ? 'bodyMediumBook' : _ref$eyebrowVariant,
      eyebrowTextTransform = _ref.eyebrowTextTransform,
      focalPointImage = _ref.focalPointImage,
      sx = _ref.sx,
      buttonIcon = _ref.buttonIcon,
      _ref$buttonIconPositi = _ref.buttonIconPosition,
      buttonIconPosition = _ref$buttonIconPositi === void 0 ? 'start' : _ref$buttonIconPositi,
      tc = _ref.tc,
      _ref$allCards = _ref.allCards,
      allCards = _ref$allCards === void 0 ? [] : _ref$allCards,
      props = _objectWithoutProperties(_ref, _excluded);

  var mobileWidth = useMediaQuery('(max-width:600px)');

  var cardThemeSwitchCase = function cardThemeSwitchCase(theme) {
    var cardBody = description ? React.createElement(TAGTypography, {
      variant: mobileWidth ? 'bodyMediumBook' : 'bodyLargeBook',
      color: "text.secondary"
    }, description) : richTextDescription ? React.createElement(RichText, {
      content: richTextDescription,
      branding: branding,
      contained: true,
      backgroundColor: backgroundColor,
      centerAlign: cardTextAlignment === 'center'
    }) : null;

    switch (theme) {
      case 'ImageOnRight':
        return React.createElement(ImageRightLayout, _objectSpread(_objectSpread({}, props), {}, {
          cardTitle: cardTitle,
          cardBody: cardBody,
          circleCheck: circleCheck,
          cardContentText: cardContentText,
          checked: checked,
          imagePath: imagePath,
          imageAltText: imageAltText,
          buttonText: buttonText,
          buttonUrl: buttonUrl,
          buttonIcon: buttonIcon,
          buttonIconPosition: buttonIconPosition,
          focalPointImage: focalPointImage
        }));

      case 'ImageOnLeft':
        return React.createElement(ImageLeftLayout, _objectSpread(_objectSpread({}, props), {}, {
          cardTitle: cardTitle,
          circleCheck: circleCheck,
          cardContentText: cardContentText,
          checked: checked,
          imagePath: imagePath,
          imageAltText: imageAltText,
          focalPointImage: focalPointImage
        }));

      default:
        return React.createElement(DefaultLayout, _objectSpread(_objectSpread({}, props), {}, {
          allCards: allCards.length ? allCards : [{
            tc: tc,
            buttonText: buttonText,
            buttonUrl: buttonUrl
          }],
          theme: theme,
          eyebrowVariant: eyebrowVariant,
          cardTextAlignment: cardTextAlignment,
          cardTitle: cardTitle,
          cardBody: cardBody,
          circleCheck: circleCheck,
          plusButtonBoolean: plusButtonBoolean,
          avatarBoolean: avatarBoolean,
          cardContentText: cardContentText,
          checked: checked,
          avatarAltText: avatarAltText,
          avatarImgPath: avatarImgPath,
          dateOfCardText: dateOfCardText,
          imagePath: imagePath,
          imageAltText: imageAltText,
          eyebrowColor: eyebrowColor,
          eyebrowTextTransform: eyebrowTextTransform,
          eyebrow: eyebrow,
          termsAndConditons: tc,
          focalPointImage: focalPointImage,
          buttonText: buttonText,
          buttonUrl: buttonUrl,
          buttonIcon: buttonIcon,
          buttonIconPosition: buttonIconPosition
        }));
    }
  };

  return React.createElement(Box, {
    sx: _objectSpread(_objectSpread({}, sx), {}, {
      position: 'relative'
    })
  }, React.createElement(Card, {
    elevation: showCardShadow ? 2 : 0,
    sx: {
      bgcolor: checked ? 'background.light' : "backgrounds.".concat(backgroundColor),
      borderRadius: '8px',
      border: '1px solid',
      width: '100%',
      borderColor: showBorder || showCardShadow ? 'neutrals.primary' : 'neutrals.white'
    }
  }, cardThemeSwitchCase(theme)));
};

export default TAGCard;